// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import etask from 'zetask';
import date from 'zdate';
import events from 'zevents';

export class Client extends events.EventEmitter {
    url: string;
    ws?: WebSocket;
    connected: boolean;
    reason?: string;
    busy: number;
    err: any;
    last_status?: string;
    reconnect_timer?: ReturnType<typeof setTimeout>;
    last_tag: number;
    last_sub_key: number;
    last_req: number;
    req: {[key: number]: (data: any)=>void};
    onopen?: ()=>void;
    onmessage?: (msg: any)=>void;
    constructor(opt: {url?: string} = {}){
        super();
        this.url = opt.url;
        this.ws = undefined;
        this.connected = false;
        this.reason = undefined;
        this.busy = 0;
        this.err = undefined;
        this.last_status = undefined;
        this.reconnect_timer = undefined;
        this.last_tag = 0;
        this.last_sub_key = 0;
        this.last_req = 0;
        this.req = {};
        this._connect();
    }
    get_status(){
        if (!this.ws)
            return this.reconnect_timer ? 'disconnected' : 'destroyed';
        if (!this.connected)
            return 'connecting';
        if (this.err)
            return 'error';
        if (this.busy)
            return 'busy';
        return 'ready';
    }
    get(method, data){
        data = data||{};
        const _this = this;
        return etask(function*(){
            _this.req[++_this.last_req] = this.continue_fn();
            const msg = Object.assign({method, key: _this.last_req, data});
            const send = ()=>_this._send({cmd: 'get', msg});
            if (!_this.connected)
                _this.once('ready', send);
            else
                send();
            return yield this.wait();
        });
    }
    _check_status(){
        let status = this.get_status();
        if (this.last_status!=status)
        {
            this.emit('status', this.last_status = status);
            this.emit(status);
        }
    }
    _connect(){
        if (this.reconnect_timer)
        {
            clearTimeout(this.reconnect_timer);
            this.reconnect_timer = undefined;
        }
        this.reason = undefined;
        this.ws = new WebSocket(this.url);
        this.ws.onopen = this._onopen.bind(this);
        this.ws.onclose = this._onclose.bind(this);
        this.ws.onmessage = this._onmessage.bind(this);
        this.ws.onerror = this._onerror.bind(this);
        this._check_status();
    }
    _send(msg){
        if (!this.ws || !this.connected || this.ws.readyState!=WebSocket.OPEN)
            return;
        this.busy++;
        this.ws.send(JSON.stringify(
            Object.assign({tag: ++this.last_tag}, msg)));
        this._check_status();
    }
    _onopen(){
        this.connected = true;
        if (this.onopen)
            this.onopen();
        this._check_status();
    }
    _onerror(event){ this._shutdown(true, event.message||'Network error'); }
    _onclose(event){ this._shutdown(true, event.reason||event.code); }
    _onmessage(event){
        try {
            let data = JSON.parse(event.data), {msg} = data;
            if (!msg)
                return;
            this.err = msg.err;
            if (this.onmessage)
                this.onmessage(msg);
            const {req} = msg;
            if (req && req.key in this.req)
            {
                this.req[req.key](req.data);
                delete this.req[req.key];
            }
            if (msg.tag)
            {
                this.busy--;
                this._check_status();
            }
            if (this.err)
                this.emit('error', this.err);
        } catch(e){
            console.error(e);
            this._shutdown(true, e.toString());
        }
    }
    _shutdown(reconnect, reason?){
        this.reason = reason;
        this.ws.onopen = undefined;
        this.ws.onclose = undefined;
        this.ws.onmessage = undefined;
        this.ws.onerror = undefined;
        this.ws.close();
        this.ws = undefined;
        this.connected = false;
        if (reconnect)
        {
            this.reconnect_timer = setTimeout(this._connect.bind(this),
                10*date.ms.SEC);
        }
        this._check_status();
    }
    destroy(){
        if (this.reconnect_timer)
        {
            clearTimeout(this.reconnect_timer);
            this.reconnect_timer = undefined;
        }
        this._shutdown(false);
    }
}
